import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionRemoveCardLabelCodes = {
  AutomationV2ExecutionActionRemoveCardLabelFailedToRemoveLabel: {
    code: 'automation-v2-execution-action/remove-card-label-failed-to-remove-label',
    explanation: `Falha ao remover a etiqueta do card.

**Causas comuns:**
- O usuário da automação não tem permissão para atualizar o card
- A etiqueta não estava adicionada ao card
- O card está arquivado ou bloqueado

**Como resolver:**
Verifique se a etiqueta está adicionada ao card e se o usuário da automação tem permissão para editar o card.`,
    localizations: {},
    message: 'A automação não conseguiu remover a etiqueta do card.',
    supportingDocs: [
      {
        name: 'Ação de Remover Etiqueta do Card',
        path: '/wiki/docs/automations/actions/remove-card-label',
      },
    ],
  },
  AutomationV2ExecutionActionRemoveCardLabelLabelNotFound: {
    code: 'automation-v2-execution-action/remove-card-label-label-not-found',
    explanation: `A etiqueta especificada não foi encontrada no fluxo do card.

**Causas comuns:**
- O nome da etiqueta foi digitado incorretamente
- A etiqueta foi excluída do fluxo
- A etiqueta pertence a outro fluxo

**Como resolver:**
Verifique se o nome ou ID da etiqueta está correto e se ela existe no fluxo do card.`,
    localizations: {},
    message: 'A etiqueta especificada não foi encontrada no fluxo do card.',
    supportingDocs: [
      {
        name: 'Ação de Remover Etiqueta do Card',
        path: '/wiki/docs/automations/actions/remove-card-label',
      },
    ],
  },
  AutomationV2ExecutionActionRemoveCardLabelMissingCardId: {
    code: 'automation-v2-execution-action/remove-card-label-missing-card-id',
    explanation: `ID do card é obrigatório no contexto da ação. O id do card é automaticamente passado pelo gatilho ou por ações anteriores.

**Causas comuns:**
- Variável cardId não resolvida
- Caso o valor do cardId seja mapeado manualmente, pode ter sido digitado incorretamente.
- Caso o valor do cardId não tenha sido mapeado, o \`context.card.id\` não está disponível.

**Como resolver:**
Corrija o mapeamento do ID do card.`,
    localizations: {},
    message:
      'Não foi possível remover a etiqueta do card porque o ID do card está faltando. Verifique se o card existe no contexto da automação ou se foi digitado corretamente.',
    supportingDocs: [
      {
        name: 'Ação de Remover Etiqueta do Card',
        path: '/wiki/docs/automations/actions/remove-card-label',
      },
      {
        name: 'Informações Dinâmicas',
        path: '/wiki/docs/automations/informacoes-dinamicas',
      },
    ],
  },
  AutomationV2ExecutionActionRemoveCardLabelMissingLabelIdOrName: {
    code: 'automation-v2-execution-action/remove-card-label-missing-label-id-or-name',
    explanation: `O ID ou nome da etiqueta não foi fornecido.

**Causas comuns:**
- O campo de etiqueta foi deixado em branco na configuração da ação
- A variável dinâmica de etiqueta retornou vazio

**Como resolver:**
Forneça o ID (UUID) ou o nome da etiqueta a ser removida.`,
    localizations: {},
    message: 'O ID ou nome da etiqueta é obrigatório para remover a etiqueta do card.',
    supportingDocs: [
      {
        name: 'Ação de Remover Etiqueta do Card',
        path: '/wiki/docs/automations/actions/remove-card-label',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
